import React, { Component } from 'react';
import { connect } from 'react-redux';
import { logOutToken } from '../actions/app_token'
import { createNewPlan, updatePlan, getPlans, loadPlan, openPlanPage, clearPlan,
getPlansFailure, loadPlanFailure, updatePlanFailure, exportPlanToExcel } from '../actions/plan'
import { toggleRisk, toggleAllRisks, clearRisk, updateRiskFailure } from '../actions/risk'
import { clearControl, getUniqueControls } from '../actions/control'
import { clearTags, updateTagsFailure } from '../actions/tags'
import { Sidebar, Segment, Button, Menu, Icon, Modal, Dropdown, Input } from 'semantic-ui-react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { Link } from 'react-router-dom'
import '../App.css';
import 'semantic-ui-css/semantic.min.css';
import history from '../history'
import {
  GET_PLANS_PATH,
  DASHBOARD_PATH,
  LOGIN_PATH,
  LOAD_PLAN_PATH,
  CREATE_PLAN_PATH,
  SYSTEM_TITLE } from '../constants'
import PlanTable from './plan_tables/plan_table'
import PlanIndexTable from './plan_tables/index_table'
import PlanControlsTable from './plan_tables/controls_table'
import PlansListModal from '../components/custom_modal'

const ReactMarkdown = require('react-markdown')

class PlanView extends Component {
  constructor(props){
    super(props);
    this.page = 1;
    this.searchTerm = '';
    this.sortBy = null;
    this.filterByTags = null;
    this.columnName = '';
    this.hiddenRisksShown = false;
    this.hiddenRiskToggled = false;
    this.exportingPlan = false;
    this.searchIconClass = 'search plus icon';
    this.searchButtonText = 'Search';

    this.state = {
      plan: {},
      plans: [],
      risks: [],
      templates: [],
      planId: 1,
      templateId: 1,
      sidebarShown: false,
      templatesModalShown: false,
      plansModalShown: false,
      pendingMessage: "",
      editing: false,
      notifications: "",
      origRisks: [],
      activeTable: 'plan_table',
      uniqueControls: [],
      searchFieldsShown: false,
      tagOptions: [],
      tagList: []
    }

  }

  componentWillMount(){
    if (!this.props.signedIn){
      return history.push(LOGIN_PATH)
    }

  }

  componentDidMount(){
    if (this.props.match.params.plan_id){
      this.props.loadPlan(parseInt(this.props.match.params.plan_id, 10), this.hiddenRisksShown, this.page, this.searchTerm, this.sortBy);
    }
  }

  componentWillReceiveProps(nextProps){
    if(this.hiddenRiskToggled) {
      if(!nextProps.riskPending) {
        this.updateRisksAfterToggle(nextProps.riskResult, nextProps.riskId, nextProps.riskHidden)
      }
      return
    }

    if (nextProps.loadSuccess) {
      var newRisks = this.state.risks.concat(this.formatRisks(nextProps.plan.risks))
      if (newRisks.length===0 && (!this.state.searchFieldsShown)){
        this.hiddenRisksShown = true;
        this.props.loadPlan(parseInt(this.props.match.params.plan_id, 10), this.hiddenRisksShown, this.page, this.searchTerm, this.sortBy);
      }
      else {
        this.setState({
          plan: nextProps.plan,
          risks: newRisks
        })
      }
      this.props.resetLoad();
    }

    if (nextProps.getPlansSuccess){
      if (nextProps.isTemplate){
        this.setState({
          templates: this.formatPlans(nextProps.plans),
          templatesModalShown: true
        })
      }
      else {
        this.setState({
          plans: this.formatPlans(nextProps.plans),
          plansModalShown: true
        })
      }
      this.props.resetGetPlans();
    }

    if (nextProps.riskPending || nextProps.updatePending){
      this.setState({
        notifications: "  (Updating...)",
      });
      this.showNotifications(false);
    }

    if (nextProps.createPending){
      this.setState({
        notifications: " (Creating...)",
      });
      this.showNotifications(false);
    }

    if (nextProps.updateRiskSuccess){
      this.showNotifications(true);
      this.updateRiskArray(this.formatRisk(nextProps.risk));
    }

    if (nextProps.updateSuccess || nextProps.updateControlSuccess || nextProps.deleteControlSuccess || nextProps.updateTagsSuccess || nextProps.createControlSuccess){
      this.setState({
        notifications: "  (All changes are saved.)",
      })
      this.showNotifications(true);
      if (nextProps.updateTagsSuccess) {
        this.props.resetUpdateTags();
      }
      else if (nextProps.updateSuccess ) {
        this.props.resetUpdate();
      }
    }

    if(nextProps.fetchUniqueSuccess) {
      this.setState({
        uniqueControls: nextProps.uniqueControls,
      })
    }

    if(this.exportingPlan && nextProps.exportSuccess) {
      this.exportingPlan = false
      this.saveExportedToExcel(nextProps.exportData)
    }

    this.setState({
      pendingMessage: nextProps.pendingMessage
    })

    this.loadingMessage(nextProps.updatePending || nextProps.createPending || nextProps.loadPending);
  };

  showNotifications(timed){
    var notifs = document.getElementById("notifications");
    notifs.style.display = "inline";
    if (timed){
      setTimeout(()=>{ notifs.style.display = "none"; }, 3000);
    }
  }

  loadingMessage(pending){
    var messageblock = document.getElementById("loading-message");
    if (pending){
      messageblock.style.display = "block";
    }
    else {
      messageblock.style.display = "none";
    }
  };

  updateRiskArray(newRisk){
    for (var i in this.state.risks){
      if(this.state.risks[i].id === newRisk.id){
        this.state.risks[i] = newRisk;
        break;
      }
    }
    this.setState({
      risks: this.state.risks,
      notifications: "All changes are saved.",
    })
    this.props.resetUpdateRisk();
  }

  formatRisks(risks) {
    var new_risks = [];
    for (var i in risks) {
      new_risks = new_risks.concat(this.formatRisk(risks[i]))
    }
    return new_risks
  }

  formatRisk(risk){
    var new_risk = {}
    var metadata = JSON.parse(risk.metadata)
    new_risk["id"] = risk.id
    new_risk["hidden"] = risk.hidden
    new_risk["activity"] = metadata["activity"]
    new_risk["step_and_hazard"] = metadata["step_and_hazard"]
    new_risk["step"] = metadata["step_and_hazard"].split(':')[0]
    var stepIndex = new_risk["step"].length + 2 //2 => column and space after step's value
    new_risk["hazard"] = metadata["step_and_hazard"].slice(stepIndex)
    new_risk["linked_to_hazard"] = metadata["linked_to_hazard"]
    new_risk["consequences_description"] = metadata["consequences_description"]
    new_risk["likelihood"] = metadata["likelihood"]["value"]+ " (" +metadata["likelihood"]["type"]+ ")"
    new_risk["highest_rating"] = risk.highest_rating
    var consequences = metadata["consequences"]
    for (var j in consequences) {
      new_risk[consequences[j].key] = consequences[j].value;
    }

    new_risk["preventative"] = JSON.stringify(risk.controls);
    return new_risk

  }

  formatPlans(plans){
    var new_plans = []
    if (plans.length===0){
      return new_plans
    }

    for (var i in plans){
      var plan = {
        key: plans[i].id,
        value: plans[i].id,
        text: plans[i].name
      }
      new_plans = new_plans.concat(plan)
    }
    return new_plans
  }

  toggleSideBar() {
    this.setState({ sidebarShown: true })
  }

  hideSideBar() {
    if (this.state.sidebarShown) {
      this.setState({ sidebarShown: false })
    }
  }

  editPlanName() {
    var edit_name = document.getElementById("editable-name");
    var static_name = document.getElementById("static-name");
    edit_name.style.display = "inline";
    static_name.style.display = "none";
  }

  updatePlanName() {
    this.setState({ editing: false })
    var static_name = document.getElementById("static-name");
    var edit_name = document.getElementById("editable-name");
    edit_name.style.display = "none";
    static_name.style.display = "inline";
    this.props.updatePlan(this.state.plan);
  }

  handleNameChange(e) {
    this.setState({ editing: true })
    var plan = {...this.state.plan}
    plan.name = e.target.value
    this.setState({ plan });
  }

  hideTemplatesModal(){
    this.setState({
      templatesModalShown: false
    })
  }

  hidePlansModal(){
    this.setState({
      plansModalShown: false
    })
  }

  showHiddenRisks(show) {
    this.hiddenRisksShown = show
    this.page = 1
    this.setState({
      risks: [],
      tagList: []
    })

    if (this.hiddenRisksShown) {
      this.filterByTags = null
      this.searchTerm = ''
    }
    this.props.loadPlan(parseInt(this.props.match.params.plan_id, 10), this.hiddenRisksShown, this.page, this.searchTerm, this.sortBy, this.columnName, this.filterByTags);

  }

  riskSelection = (row, isSelect) => {
    this.hiddenRiskToggled = true
    this.props.toggleRisk(this.state.plan.id, row.id, !isSelect)
  }

  riskSelectionAll = (isSelect) => {
    this.hiddenRiskToggled = true
    this.props.toggleAllRisks(this.state.plan.id, !isSelect)
  }

  selectedRisks() {
    const risks = this.state.risks
    var selected = []
    for (var i in risks) {
      if(!risks[i]["hidden"]) {
        selected.push(risks[i].id)
      }
    }
    return selected
  }

  updateRisksAfterToggle(result, riskId, hidden) {
    this.hiddenRiskToggled = false

    if(!result || riskId == null) {
      return
    }

    var risks = this.state.risks

    for (var i in risks) {
      if(riskId != 'all' && riskId != risks[i].id) {
        continue
      }

      risks[i]['hidden'] = hidden

      if(riskId != 'all' && riskId == risks[i].id) {
        break
      }
    }

    this.setState({
      risks: risks
    })
  }

  fetchMoreRisk = () => {
    this.page++
    this.props.loadPlan(parseInt(this.props.match.params.plan_id, 10), this.hiddenRisksShown, this.page, this.searchTerm, this.sortBy, this.columnName, this.filterByTags);
  };

  loadPlan() {
    this.page = 1
    this.setState({
      risks: []
    })
    this.props.loadPlan(parseInt(this.props.match.params.plan_id, 10), this.hiddenRisksShown, this.page, this.searchTerm, this.sortBy, this.columnName, this.filterByTags);
  }

  setSearchTerm(searchTerm){
    this.searchTerm = searchTerm
  }

  setColumnName(columnName){
    this.columnName = columnName
  }

  setFilterByTags(filterByTags){
    this.filterByTags = filterByTags
  }

  setSortBy(sortBy){
    this.sortBy = sortBy
  }

  renderLoadingMessage(){
    return (
      <div id="loading-message">
        <i className="loading circle notched icon plan-loading"></i>
        <span>{this.state.pendingMessage}</span>
      </div>
    )
  }

  onTabMenuClick(activeTable) {
    if(this.state.activeTable == activeTable) {
      // tab is not changed
      return
    }

    if(this.props.loadPending || this.props.controlPending) {
      // data still loading
      return
    }

    this.setState({
      activeTable: activeTable,
      uniqueControls: []
    })

    if(activeTable === 'plan_control_table') {
      this.props.getUniqueControls(this.state.plan.id, this.searchTerm, this.sortBy, this.columnName, this.filterByTags)
    }
    else {
      this.showHiddenRisks(false)
    }
  }

  exportToExcel() {
    if(this.props.exportPending) {
      // already exporting
      return
    }
    this.exportingPlan = true
    this.props.exportPlanToExcel(this.state.plan.id, this.hiddenRisksShown, this.searchTerm, this.sortBy, this.columnName, this.filterByTags)
  }

  saveExportedToExcel(data) {
    const filename = this.state.plan.name + '.xlsx'
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  toggleSearchState(){
    this.searchTerm = '';
    this.filterByTags = null;
    this.columnName = '';
    this.setState({
      tagList: [],
      searchFieldsShown: !this.state.searchFieldsShown
    })
    this.loadPlan();
  }

  handleFilterByTags(evt, data){
    this.setState({
      tagList: data.value
    })
    this.columnName = '';
    this.searchTerm = data.value;
    this.filterByTags = true;
    this.loadPlan();
  }

  handleFilterByTagsFocus(evt, data){
    if (this.state.searchFieldsShown){
      this.setState({ searchFieldsShown: false })
    }
  }

  setTagOptions(tag){
    var found = this.state.tagOptions.some((el) => {
      return el.key === tag.key;
    });
    if (!found) {
      this.state.tagOptions.push(tag);
    }

    this.setState({
      tagOptions: this.state.tagOptions
    })
  }

  resetFilters() {
    this.sortBy = null
    this.searchTerm = '';
    this.filterByTags = null;
    this.columnName = '';
    this.setState({
      tagList: [],
      searchFieldsShown: false
    })
    this.loadPlan();
  }

  planTablesTabMenu(activeTable) {
    return (
      <Menu>
        <Menu.Item
          name='plan_table'
          active={activeTable === 'plan_table'}
          onClick={(evt)=>this.onTabMenuClick('plan_table')}
        >
          {((this.props.loadPending || this.props.riskPending) && activeTable === 'plan_table') && <i className="loading circle notched icon"></i>} Project Control Register
        </Menu.Item>
        {!this.hiddenRisksShown && <Menu.Item
          name='plan_index_table'
          active={activeTable === 'plan_index_table'}
          onClick={(evt)=>this.onTabMenuClick('plan_index_table')}
        >
          {(this.props.loadPending && activeTable === 'plan_index_table') && <i className="loading circle notched icon"></i>} Index
        </Menu.Item>}
        {!this.hiddenRisksShown && <Menu.Item
          name='plan_control_table'
          active={activeTable === 'plan_control_table'}
          onClick={(evt)=>this.onTabMenuClick('plan_control_table')}
        >
          {this.props.controlPending && activeTable === 'plan_control_table' && <i className="loading circle notched icon"></i>} Controls
        </Menu.Item>}
        {(activeTable === 'plan_table') && <div className='filter-div '>
          <div className="search-button-div">
            <Button toggle active={this.state.searchFieldsShown} onClick={()=>this.toggleSearchState()}><i className={this.searchIconClass}></i>{this.searchButtonText}</Button>
          </div>
          {!this.hiddenRisksShown && <div id="filter-by-tags">
            <Dropdown
              ref="tags-dropdown"
              id="filter-by-tags-dropdown"
              className="filter-by-tags-dropdown"
              placeholder='Filter by Tags'
              fluid
              multiple
              search
              selection
              options={this.state.tagOptions}
              value={this.state.tagList}
              onChange={(evt, data)=>this.handleFilterByTags(evt, data)}
              closeOnBlur={true}
              onFocus={(evt, data) => this.handleFilterByTagsFocus(evt, data)}>
            </Dropdown>
          </div>}
          {(this.state.searchFieldsShown|| this.filterByTags != null || this.sortBy != null) && <div className="reset-button-div">
            <Button className="reset-button-div" onClick={()=>this.resetFilters()}><Icon name='remove'></Icon>Reset</Button>
          </div>}
        </div>}
      </Menu>
    )
  }

  render(props) {
    const { sidebarShown, plan, activeTable } = this.state
    const createPlanItem = <Menu.Item name='templates' onClick={() => this.props.getTemplates()}><Icon name='plus'></Icon>New Plan</Menu.Item>
    const loadPlanItem = <Menu.Item name='plans' onClick={() => this.props.getPlans()}><Icon name='file alternate'></Icon>Open Plan</Menu.Item>
    const selectRow = {
      mode: 'checkbox',
      clickToSelect: false,
      selected: this.selectedRisks(),
      hideSelectColumn: !this.hiddenRisksShown,
      onSelect: this.riskSelection,
      onSelectAll: this.riskSelectionAll
    }
    return (
      <div className="App">
        <Sidebar.Pushable as={Segment} id='plan-segment'>
          <Sidebar
            as={Menu}
            animation='overlay'
            width='thin'
            visible={sidebarShown}
            icon='labeled'
            vertical
            inverted
            onMouseLeave={() => this.hideSideBar()}
          >
            <Menu.Item name='home' as={Link} to={DASHBOARD_PATH}>
              <Icon name='home'></Icon>
              Dashboard
            </Menu.Item>
            <PlansListModal
              trigger={createPlanItem}
              options={this.state.templates}
              type="Template"
              shown={this.state.templatesModalShown}
              callback={this.props.newPlan}
              pending={this.state.planPending}
              onClose={()=>this.hideTemplatesModal()}/>
            <PlansListModal
              trigger={loadPlanItem}
              options={this.state.plans}
              type="Plan"
              shown={this.state.plansModalShown}
              callback={this.props.openPlanPage}
              pending={this.state.planPending}
              onClose={()=>this.hidePlansModal()}/>
            {!this.hiddenRisksShown && <Menu.Item name='export_to_excel' onClick={() => {this.setState({activeTable: "plan_table"}),this.showHiddenRisks(true), this.hideSideBar()}}>
                <Icon name='eye'></Icon>
                <div>Show unselected activities</div>
            </Menu.Item>
            }
             <Segment vertical>
              <Menu.Item name='export_to_excel' onClick={() => this.exportToExcel()}>
                  <Icon name='download'></Icon>
                  <div>{this.props.exportPending && <i className="loading circle notched icon"></i>} Export to Excel</div>
              </Menu.Item>
            </Segment>
          </Sidebar>
          <Sidebar.Pusher>
            <Segment basic>
              <i className="bars icon" onClick={() => this.toggleSideBar()}></i>
              <header className="App-header">
                <h1 className="App-title">
                  <span>{SYSTEM_TITLE}</span>
                  <span id="static-name">
                    <span className="static-name">- {plan.name}</span>
                    <i onClick={() => this.editPlanName()} className="edit icon edit-button" title="Edit the Plan Name"></i>
                  </span>
                  <span className="ui input" id="editable-name"> -
                    <input type="text" value={plan.name} onChange={ this.handleNameChange.bind(this) }></input>
                    <i onClick={() => this.updatePlanName()} className="save icon save-button" title="Save the Plan Name"></i>
                  </span>
                  <span id="notifications">{this.state.notifications}</span>
                </h1>

              </header>
              <Button color='red' fluid size='medium' onClick={() => this.props.logout(this.props.token)} className="log-out-button">Logout</Button>
              {this.planTablesTabMenu(activeTable)}

              {(activeTable === 'plan_table') &&  <div className="plan-table">
                <InfiniteScroll
                  dataLength={this.state.risks.length}
                  next={this.fetchMoreRisk}
                  hasMore={true}
                  loader={this.renderLoadingMessage()}
                  scrollableTarget='plan-segment'
                  endMessage={
                    <p style={{ textAlign: 'center' }}>
                      <b>End of Records</b>
                    </p>
                  }
                >
                  <PlanTable
                    risks={ this.state.risks }
                    shouldNotRender={ this.state.sidebarShown || this.state.editing }
                    planId={this.state.plan.id}
                    selectRow={ selectRow }
                    hiddenRisksShown={this.hiddenRisksShown}
                    showHiddenRisks={ (show) => this.showHiddenRisks(show) }
                    setSearchTerm={ this.setSearchTerm.bind(this) }
                    setColumnName={ this.setColumnName.bind(this) }
                    setFilterByTags={ this.setFilterByTags.bind(this) }
                    setSortBy={ this.setSortBy.bind(this) }
                    sortBy={this.sortBy}
                    loadPlan={ this.loadPlan.bind(this) }
                    searchFieldsShown={ this.state.searchFieldsShown }
                    setTagOptions={ this.setTagOptions.bind(this) }
                  />
                </InfiniteScroll>
              </div>
              }
              {(activeTable === 'plan_index_table') && <div className="plan-table">
                <InfiniteScroll
                  dataLength={this.state.risks.length}
                  next={this.fetchMoreRisk}
                  hasMore={true}
                  loader={this.renderLoadingMessage()}
                  scrollableTarget='plan-segment'
                  endMessage={
                    <p style={{ textAlign: 'center' }}>
                      <b>End of Records</b>
                    </p>
                  }
                >
                  <PlanIndexTable
                      risks={ this.state.risks }
                      shouldNotRender={ this.state.sidebarShown || this.state.editing }
                      planId={this.state.plan.id}
                      selectRow={ selectRow }
                      hiddenRisksShown={this.hiddenRisksShown}
                    />
                </InfiniteScroll>
              </div>}
              {(activeTable === 'plan_control_table') && <div className="plan-table">
                <InfiniteScroll
                  dataLength={this.state.uniqueControls.length}
                  hasMore={true}
                  loader={this.renderLoadingMessage()}
                  scrollableTarget='plan-segment'
                  endMessage={
                    <p style={{ textAlign: 'center' }}>
                      <b>End of Records</b>
                    </p>
                  }
                >
                  <PlanControlsTable
                    controls = { this.state.uniqueControls }
                    shouldNotRender={ this.state.sidebarShown || this.state.editing }
                    planId={this.state.plan.id}
                    selectRow={ selectRow }
                    hiddenRisksShown={this.hiddenRisksShown}
                  />
                </InfiniteScroll>
              </div>}
            </Segment>
          </Sidebar.Pusher>
        </Sidebar.Pushable>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.app_token.accessToken,
    signedIn: state.app_token.signedIn,
    plan: state.plan.plan,
    plans: state.plan.plans,
    pendingMessage: state.plan.pendingMessage,
    createSuccess: state.plan.createSuccess,
    createPending: state.plan.createPending,
    loadSuccess: state.plan.loadSuccess,
    loadPending: state.plan.loadPending,
    updateSuccess: state.plan.updateSuccess,
    updatePending: state.plan.updatePending,
    getPlansSuccess: state.plan.getPlansSuccess,
    getPlansPending: state.plan.getPlansPending,
    isTemplate: state.plan.isTemplate,
    exportPending: state.plan.exportPending,
    exportSuccess: state.plan.exportSuccess,
    exportData: state.plan.exportData,
    riskPending: state.risk.pending,
    riskMessage: state.risk.message,
    riskResult: state.risk.result,
    riskId: state.risk.id,
    riskHidden: state.risk.hidden,
    updateRiskSuccess: state.risk.updateSuccess,
    riskCellValue: state.risk.cellValue,
    riskRow: state.risk.row,
    risk: state.risk.risk,
    createControlSuccess: state.control.createSuccess,
    updateControlSuccess: state.control.updateSuccess,
    deleteControlSuccess: state.control.deleteSuccess,
    fetchUniqueSuccess: state.control.fetchUniqueSuccess,
    uniqueControls: state.control.uniqueControls,
    controlPending: state.control.pending,
    updateTagsSuccess: state.tags.updateSuccess,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    logout: (token) => {
      dispatch(logOutToken(token))
    },
    newPlan: (template_plan_id) => {
      dispatch(createNewPlan(template_plan_id))
    },
    updatePlan: (plan) => {
      dispatch(updatePlan(plan))
    },
    loadPlan: (plan_id, include_hidden_risks, page, search_term, sort_by, column_name, filterByTags) => {
      dispatch(loadPlan(plan_id, include_hidden_risks, page, search_term, sort_by, column_name, filterByTags))
    },
    getPlans: () => {
      dispatch(getPlans(null))
    },
    getTemplates: () => {
      dispatch(getPlans(true));
    },
    openPlanPage: (plan_id) => {
      openPlanPage(plan_id);
    },
    toggleRisk: (plan_id, risk_id, hidden) => {
      dispatch(toggleRisk(plan_id, risk_id, hidden))
    },
    toggleAllRisks: (plan_id, hidden) => {
      dispatch(toggleAllRisks(plan_id, hidden))
    },
    resetGetPlans: () => {
      dispatch(getPlansFailure());
    },
    resetLoad: () => {
      dispatch(loadPlanFailure());
    },
    resetUpdateRisk: () => {
      dispatch(updateRiskFailure());
    },
    resetUpdateTags: () => {
      dispatch(updateTagsFailure());
    },
    resetUpdate: () => {
      dispatch(updatePlanFailure());
    },
    clearStates: () => {
      dispatch(clearPlan());
      dispatch(clearRisk());
      dispatch(clearControl());
      dispatch(clearTags());
    },
    getUniqueControls: (plan_id, search_term, sort_by, column_name, filterByTags) => {
      dispatch(getUniqueControls(plan_id, search_term, sort_by, column_name, filterByTags))
    },
    exportPlanToExcel: (plan_id, include_hidden_risks, search_term, sort_by, column_name, filterByTags) => {
      dispatch(exportPlanToExcel(plan_id, include_hidden_risks, search_term, sort_by, column_name, filterByTags))
    },
  }
}

let PlanViewPage = connect(mapStateToProps, mapDispatchToProps)(PlanView)
export default PlanViewPage;



// WEBPACK FOOTER //
// ./src/views/plan.js